<template>
  <div class="main">
     <div v-if="loading" class="loading">
         <span></span>
     </div>
     <div v-else class="weather day" >
         <div class="weather-wrap">
         <CurrentWeather :currentWeather="currentWeather" />
         <HourlyWeather :forecast="forecast"  />
         <WeeklyForecast :forecast="forecast" />
         <AdditionalInfo :currentWeather="currentWeather"/>
         </div>
     </div>
 </div>
</template>

<script>
import axios from "axios";
import db from "../firebase/firebaseinit";
import CurrentWeather from "../components/CurrentWeather";
import HourlyWeather from "../components/HourlyWeather";
import WeeklyForecast from "../components/WeeklyForecast";
import AdditionalInfo from "../components/AdditionalInfo";
export default {
    name : "Weather",
    props: ["APIkey"],
    components: {
        CurrentWeather,
        HourlyWeather,
        WeeklyForecast,
        AdditionalInfo,
    },
    data() {
        return {
            forecast: null,
            currentWeather: null,
            loading: true,
            };
    },
    created() {
        this.getWeather();
    },
     methods: {
        getWeather () {
            db.collection('cities')
            .where('city', '==', `${this.$route.params.city}`)
            .get()
            .then((docs) => {
                docs.forEach(doc => {
                    this.currentWeather = doc.data().currentWeather;
                    axios
                    .get(
                        `https://api.openweathermap.org/data/2.5/onecall?lat=${doc.data().currentWeather.coord.lat}&lon=${doc.data().currentWeather.coord.lon}&exclude=current,minutley,alert&units=metric&appid=${this.APIkey}`
                    ).then(res => {
                        this.forecast = res.data;
                    }).then(() => {
                        this.loading = false;
                    })
                });
            });   
        },
    },
};
</script>

<style lang="scss" scoped>
.loading {
    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }
    display: flex;
    height: 100%;
    width: 100%;
    justify-content: center;
    align-items: center;
    span {
        display: block;
        width: 60px;
        height: 60px;
        margin: 0 auto;
        border: 2px solid transparent;
        border-top-color: #142a5f;
        border-radius: 50%;
        animation: spin ease 1000ms infinite;
    }
}
.weather {
    transition: 500ms ease;
    overflow: scroll;
    width: 100%;
    height: 100%;
    
    &::-webkit-scrollbar {
            display: none;
        }
    
    .weather-wrap {
        overflow: hidden;
        max-width: 1024px;
        margin: 0 auto;
    }
}

</style>
